import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: resolve => require(['@/components/Index'], resolve),
      meta:{
        title:'首页',
      }
    },
    // 专业页面
    {
      path: '/xd',
      name: 'MajorXd',
      component: resolve => require(['@/components/Major/MajorXd'], resolve),
    },
    {
      path: '/xc',
      name: 'MajorXc',
      component: resolve => require(['@/components/Major/MajorXc'], resolve),
    },
    {
      path: '/tj',
      name: 'MajorTj',
      component: resolve => require(['@/components/Major/MajorTj'], resolve),
    },
    {
      path: '/kf',
      name: 'MajorKf',
      component: resolve => require(['@/components/Major/MajorKf'], resolve),
    },
    // 关于欧米奇
    {
      path: '/brand',
      name: 'Brand',
      component: resolve => require(['@/components/Brand/Brand'], resolve),
    },
    // 创就业
    {
      path: '/cjy',
      name: 'Cjy',
      component: resolve => require(['@/components/Cjy/Cjy'], resolve),
      children:[
        {
          path:'/cjy/Jy',
          name:'Jy',
          component: resolve => require(['@/components/Cjy/Jy'], resolve),
        },
        {
          path:'/cjy/Cy',
          name:'Cy',
          component: resolve => require(['@/components/Cjy/Cy'], resolve),
        }
      ]
    },
    // 新闻页面
    {
      path: '/news',
      name: 'News',
      component: resolve => require(['@/components/News/News'], resolve),
      children:[
        {
          path:'/news/PhotoA',
          component: resolve => require(['@/components/News/PhotoA'], resolve),
        },
        {
          path:'/news/PhotoB',
          component: resolve => require(['@/components/News/PhotoB'], resolve),
        },
        {
          path:'/news/PhotoC',
          component: resolve => require(['@/components/News/PhotoC'], resolve),
        },
        {
          path:'/news/PhotoD',
          component: resolve => require(['@/components/News/PhotoD'], resolve),
        }
      ]
    },
    // 教师页面
    {
      path: '/teacher',
      name: 'Teacher',
      component: resolve => require(['@/components/Teacher/Teacher'], resolve),
    },
    // 学生作品
    {
      path: '/student',
      name: 'Student',
      component: resolve => require(['@/components/Student/Student'], resolve),
    },
      // 女生页面
    {
        path: '/girl',
        name: 'girl',
        component: resolve => require(['@/components/girl/girl'], resolve),
      },
    // 学校环境
    {
      path: '/ambient',
      name: 'Ambient',
      component: resolve => require(['@/components/Ambient/Ambient'], resolve),
    },
    // 西点专业页面
    {
      path: '/xdFifteen',
      name: 'xdFifteen',
      component: resolve => require(['@/components/MajorColumns/xdFifteen'], resolve),
    },
    {
      path: '/xdNine',
      name: 'xdNine',
      component: resolve => require(['@/components/MajorColumns/xdNine'], resolve),
    },
    {
      path: '/xdSix',
      name: 'xdSix',
      component: resolve => require(['@/components/MajorColumns/xdSix'], resolve),
    },
    {
      path: '/xdThree',
      name: 'xdThree',
      component: resolve => require(['@/components/MajorColumns/xdThree'], resolve),
    },
    // 西餐专业页面
    {
      path: '/xcFifteen',
      name: 'xcFifteen',
      component: resolve => require(['@/components/MajorColumns/xcFifteen'], resolve),
    },
    {
      path: '/xcNine',
      name: 'xcNine',
      component: resolve => require(['@/components/MajorColumns/xcNine'], resolve),
    },
    {
      path: '/xcSix',
      name: 'xcSix',
      component: resolve => require(['@/components/MajorColumns/xcSix'], resolve),
    },
    {
      path: '/xcThree',
      name: 'xcThree',
      component: resolve => require(['@/components/MajorColumns/xcThree'], resolve),
    },
    // 新闻详情页
    // 学校新闻
    {
      path: '/PhotoA0001',
      component: resolve => require(['@/components/News/PhotoA/0001'], resolve),
    },
    {
      path: '/PhotoA0002',
      component: resolve => require(['@/components/News/PhotoA/0002'], resolve),
    },
    {
      path: '/PhotoA0003',
      component: resolve => require(['@/components/News/PhotoA/0003'], resolve),
    },
    {
      path: '/PhotoA0004',
      component: resolve => require(['@/components/News/PhotoA/0004'], resolve),
    },
    {
      path: '/PhotoA0005',
      component: resolve => require(['@/components/News/PhotoA/0005'], resolve),
    },
    {
      path: '/PhotoA0006',
      component: resolve => require(['@/components/News/PhotoA/0006'], resolve),
    },
    {
      path: '/PhotoA0007',
      component: resolve => require(['@/components/News/PhotoA/0007'], resolve),
    },
    {
      path: '/PhotoA0008',
      component: resolve => require(['@/components/News/PhotoA/0008'], resolve),
    },
    {
      path: '/PhotoA0009',
      component: resolve => require(['@/components/News/PhotoA/0009'], resolve),
    },
    {
      path: '/PhotoA0010',
      component: resolve => require(['@/components/News/PhotoA/0010'], resolve),
    },
    {
      path: '/PhotoA0011',
      component: resolve => require(['@/components/News/PhotoA/0011'], resolve),
    },
    {
      path: '/PhotoA0012',
      component: resolve => require(['@/components/News/PhotoA/0012'], resolve),
    },
    {
      path: '/PhotoA0013',
      component: resolve => require(['@/components/News/PhotoA/0013'], resolve),
    },
    {
      path: '/PhotoA0014',
      component: resolve => require(['@/components/News/PhotoA/0014'], resolve),
    },
    {
      path: '/PhotoA0015',
      component: resolve => require(['@/components/News/PhotoA/0015'], resolve),
    },
    {
      path: '/PhotoA0016',
      component: resolve => require(['@/components/News/PhotoA/0016'], resolve),
    },
    {
      path: '/PhotoA0017',
      component: resolve => require(['@/components/News/PhotoA/0017'], resolve),
    },
    {
      path: '/PhotoA0018',
      component: resolve => require(['@/components/News/PhotoA/0018'], resolve),
    },
    {
      path: '/PhotoA0019',
      component: resolve => require(['@/components/News/PhotoA/0019'], resolve),
    },
    {
      path: '/PhotoA0020',
      component: resolve => require(['@/components/News/PhotoA/0020'], resolve),
    },
    {
      path: '/PhotoA0021',
      component: resolve => require(['@/components/News/PhotoA/0021'], resolve),
    },
    // 行业资讯
    {
      path: '/PhotoB0001',
      component: resolve => require(['@/components/News/PhotoB/0001'], resolve),
    },
    {
      path: '/PhotoB0002',
      component: resolve => require(['@/components/News/PhotoB/0002'], resolve),
    },
    {
      path: '/PhotoB0003',
      component: resolve => require(['@/components/News/PhotoB/0003'], resolve),
    },
    {
      path: '/PhotoB0004',
      component: resolve => require(['@/components/News/PhotoB/0004'], resolve),
    },
    {
      path: '/PhotoB0005',
      component: resolve => require(['@/components/News/PhotoB/0005'], resolve),
    },
    {
      path: '/PhotoB0006',
      component: resolve => require(['@/components/News/PhotoB/0006'], resolve),
    },
    {
      path: '/PhotoB0007',
      component: resolve => require(['@/components/News/PhotoB/0007'], resolve),
    },
    {
      path: '/PhotoB0008',
      component: resolve => require(['@/components/News/PhotoB/0008'], resolve),
    },
    {
      path: '/PhotoB0009',
      component: resolve => require(['@/components/News/PhotoB/0009'], resolve),
    },
    {
      path: '/PhotoB0010',
      component: resolve => require(['@/components/News/PhotoB/0010'], resolve),
    },
    {
      path: '/PhotoB0011',
      component: resolve => require(['@/components/News/PhotoB/0011'], resolve),
    },
    {
      path: '/PhotoB0012',
      component: resolve => require(['@/components/News/PhotoB/0012'], resolve),
    },
    {
      path: '/PhotoB0013',
      component: resolve => require(['@/components/News/PhotoB/0013'], resolve),
    },
    {
      path: '/PhotoB0014',
      component: resolve => require(['@/components/News/PhotoB/0014'], resolve),
    },
    {
      path: '/PhotoB0015',
      component: resolve => require(['@/components/News/PhotoB/0015'], resolve),
    },
    {
      path: '/PhotoB0016',
      component: resolve => require(['@/components/News/PhotoB/0016'], resolve),
    },
    {
      path: '/PhotoB0017',
      component: resolve => require(['@/components/News/PhotoB/0017'], resolve),
    },
    {
      path: '/PhotoB0018',
      component: resolve => require(['@/components/News/PhotoB/0018'], resolve),
    },
    {
      path: '/PhotoB0019',
      component: resolve => require(['@/components/News/PhotoB/0019'], resolve),
    },
    {
      path: '/PhotoB0020',
      component: resolve => require(['@/components/News/PhotoB/0020'], resolve),
    },
    {
      path: '/PhotoB0021',
      component: resolve => require(['@/components/News/PhotoB/0021'], resolve),
    },
    {
      path: '/PhotoB0022',
      component: resolve => require(['@/components/News/PhotoB/0022'], resolve),
    },
    {
      path: '/PhotoB0023',
      component: resolve => require(['@/components/News/PhotoB/0023'], resolve),
    },
    {
      path: '/PhotoB0024',
      component: resolve => require(['@/components/News/PhotoB/0024'], resolve),
    },
    {
      path: '/PhotoB0025',
      component: resolve => require(['@/components/News/PhotoB/0025'], resolve),
    },
    {
      path: '/PhotoB0026',
      component: resolve => require(['@/components/News/PhotoB/0026'], resolve),
    },
    {
      path: '/PhotoB0027',
      component: resolve => require(['@/components/News/PhotoB/0027'], resolve),
    },
    {
      path: '/PhotoB0028',
      component: resolve => require(['@/components/News/PhotoB/0028'], resolve),
    },
    {
      path: '/PhotoB0029',
      component: resolve => require(['@/components/News/PhotoB/0029'], resolve),
    },
    {
      path: '/PhotoB0030',
      component: resolve => require(['@/components/News/PhotoB/0030'], resolve),
    },
    // 学员风采
    {
      path: '/PhotoC0001',
      component: resolve => require(['@/components/News/PhotoC/0001'], resolve),
    },
    {
      path: '/PhotoC0002',
      component: resolve => require(['@/components/News/PhotoC/0002'], resolve),
    },
    {
      path: '/PhotoC0003',
      component: resolve => require(['@/components/News/PhotoC/0003'], resolve),
    },
    {
      path: '/PhotoC0004',
      component: resolve => require(['@/components/News/PhotoC/0004'], resolve),
    },
    {
      path: '/PhotoC0005',
      component: resolve => require(['@/components/News/PhotoC/0005'], resolve),
    },
    {
      path: '/PhotoC0006',
      component: resolve => require(['@/components/News/PhotoC/0006'], resolve),
    },
    {
      path: '/PhotoC0007',
      component: resolve => require(['@/components/News/PhotoC/0007'], resolve),
    },
    {
      path: '/PhotoC0008',
      component: resolve => require(['@/components/News/PhotoC/0008'], resolve),
    },
    {
      path: '/PhotoC0009',
      component: resolve => require(['@/components/News/PhotoC/0009'], resolve),
    },
    {
      path: '/PhotoC0010',
      component: resolve => require(['@/components/News/PhotoC/0010'], resolve),
    },
    {
      path: '/PhotoC0011',
      component: resolve => require(['@/components/News/PhotoC/0011'], resolve),
    },
    {
      path: '/PhotoC0012',
      component: resolve => require(['@/components/News/PhotoC/0012'], resolve),
    },
    {
      path: '/PhotoC0013',
      component: resolve => require(['@/components/News/PhotoC/0013'], resolve),
    },
    {
      path: '/PhotoC0014',
      component: resolve => require(['@/components/News/PhotoC/0014'], resolve),
    },
    {
      path: '/PhotoC0015',
      component: resolve => require(['@/components/News/PhotoC/0015'], resolve),
    },
    {
      path: '/PhotoC0016',
      component: resolve => require(['@/components/News/PhotoC/0016'], resolve),
    },
    {
      path: '/PhotoC0017',
      component: resolve => require(['@/components/News/PhotoC/0017'], resolve),
    },
    // 入学答疑
    {
      path: '/PhotoD0001',
      component: resolve => require(['@/components/News/PhotoD/0001'], resolve),
    },
    {
      path: '/PhotoD0002',
      component: resolve => require(['@/components/News/PhotoD/0002'], resolve),
    },
    {
      path: '/PhotoD0003',
      component: resolve => require(['@/components/News/PhotoD/0003'], resolve),
    },
    {
      path: '/PhotoD0004',
      component: resolve => require(['@/components/News/PhotoD/0004'], resolve),
    },
    {
      path: '/PhotoD0005',
      component: resolve => require(['@/components/News/PhotoD/0005'], resolve),
    },
    {
      path: '/PhotoD0006',
      component: resolve => require(['@/components/News/PhotoD/0006'], resolve),
    },
    {
      path: '/PhotoD0007',
      component: resolve => require(['@/components/News/PhotoD/0007'], resolve),
    },
    {
      path: '/PhotoD0008',
      component: resolve => require(['@/components/News/PhotoD/0008'], resolve),
    },
    {
      path: '/PhotoD0009',
      component: resolve => require(['@/components/News/PhotoD/0009'], resolve),
    },
    {
      path: '/PhotoD0010',
      component: resolve => require(['@/components/News/PhotoD/0010'], resolve),
    },
    {
      path: '/PhotoD0011',
      component: resolve => require(['@/components/News/PhotoD/0011'], resolve),
    },
    {
      path: '/PhotoD0012',
      component: resolve => require(['@/components/News/PhotoD/0012'], resolve),
    },
    {
      path: '/PhotoD0013',
      component: resolve => require(['@/components/News/PhotoD/0013'], resolve),
    },
    {
      path: '/PhotoD0014',
      component: resolve => require(['@/components/News/PhotoD/0014'], resolve),
    },
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js